import React from 'react'
import { Columns } from 'src/components'
/**
 * A simple toolbar container for the [Modal](#Modal) component.
 */
const ModalToolbar = props => <Columns layout="auto" justify="end" {...props} />

export default ModalToolbar
